import Vue from 'vue'
import Router from 'vue-router'
import Main from '../pages/main'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      redirect: '/home',
      component: Main,
      children: [
        {
          path: '/home',
          name: 'home',
          component: () => import('../pages/home-pc')
        },
        {
          path: '/solution',
          name: 'solution',
          meta: { title: '飞联网' },
          component: () => import('../pages/solution')
        },
        {
          path: '/company',
          name: 'company',
          meta:{ title: '公司简介' },
          component: () => import('../pages/abouts')
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js